import { alpha } from '@mui/material';

import { getScrollStyles } from 'styles/scrollbar.styles';
import { getAlphaCompositionRGBColor } from 'utils/colorConversion';
import { checkIsDarkTheme } from 'utils/theme';

const BASE_PADDING_PX = 16;
const NESTED_PADDING_PX = 15;
const SUBHEADER_PADDING_PX = 10;
const FADE_OPACITY = 0.08;
const FOCUS_OUTLINE_WIDTH_PX = 2;

export const getStyles = (theme, { depth } = {}) => {
  const isDarkTheme = checkIsDarkTheme(theme.palette.type);

  // The global `* { outline: none !important }` reset hides the native focus ring.
  const focusVisible = {
    '&.Mui-focusVisible': {
      outline: `${FOCUS_OUTLINE_WIDTH_PX}px solid ${theme.palette.primary.main} !important`,
      outlineOffset: `-${FOCUS_OUTLINE_WIDTH_PX}px`,
    },
  };

  return {
    wrapper: {
      maxHeight: '484px !important',
      overflow: 'hidden',
    },
    list: {
      width: '320px',
      height: '390px',
      overflowY: 'scroll',
      ...getScrollStyles(theme).scroll,
    },
    searchContainer: {
      padding: '20px 16px 8px',
    },
    listItem: {
      paddingLeft: `${BASE_PADDING_PX + (depth || 0) * NESTED_PADDING_PX}px`,
      color: theme.palette.text.primary,
      ...focusVisible,
    },
    listItemText: {
      minWidth: 0,
      '& .MuiListItemText-primary': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
    },
    expandIcon: {
      color: isDarkTheme ? theme.palette.common.white : null,
      marginLeft: '5px',
    },
    listSubHeader: {
      backgroundColor: theme.palette.background.paper,
    },
    listSubHeaderButton: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: `${BASE_PADDING_PX + (depth || 0) * SUBHEADER_PADDING_PX}px`,
      ...focusVisible,
      '&:hover': {
        backgroundColor: getAlphaCompositionRGBColor({
          primaryColor: alpha(theme.palette.common.white, FADE_OPACITY),
          secondaryColor: theme.palette.background.paper,
        }),
      },
    },
    popupButtonOptions: {
      '& button': {
        borderRadius: 0,

        '&:not(:last-child)': {
          borderRight: `1px solid ${theme.palette.divider}`,
        },
      },
    },
  };
};
